import React, {useContext, useState} from 'react';
import noteContext from '../context/notes/noteContext';


const AddNote = (props) => {
  const context = useContext(noteContext);
  // eslint-disable-next-line
  const {addNote} = context;
  const [note, setNote] = useState({title: "", description: "", tag: ""});

  const handleClick = (e)=>{
    e.preventDefault();
    addNote(note.title, note.description, note.tag);
    setNote({title: "", description: "", tag: ""});
    props.showAlert("Added Successfully", "success");
  }

  const onChange = (e)=>{
    setNote({...note, [e.target.name]: e.target.value});
  }
  return (
    <div>
      <div className="container my-5">
        <h2>Add a Note</h2>
        <form className='my-3'>
          <div className="mb-3">
            <label htmlFor="title" className="form-label">Title</label>
            <input type="text" className="form-control" id="title"  value={note.title} name='title' aria-describedby="emailHelp" onChange={onChange} minLength={3} required/>
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label">Description</label>
            <input type="text" className="form-control" id="description" value={note.description} name="description" onChange={onChange} minLength={5} required/>
          </div>
          <div className="mb-3">
            <label htmlFor="tag" className="form-label">Tag</label>
            <input type="text" className="form-control" value={note.tag} id="tag" name="tag" onChange={onChange}/>
          </div>
          <button disabled={note.title.length<3 || note.description.length<5} type="submit" className="btn" style={{"backgroundColor": "#8430D3", "color":"white"}} onClick={handleClick}>Add Note</button>
        </form>
      </div>
    </div>
  );
}

export default AddNote;
